import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import { evalEventsKey } from 'features/evaluations/metadata/utils/evalDataKeys'
import { loadEvalEvents } from 'features/evaluations/metadata/utils/loadEvalEvents'
import type { DocumentPageMetadataUserEditEntry } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'
import type { MetadataUserEditLoadOptions } from 'features/knowledgeDocumentViewer/utils/documentEntryLookups'
import useSWR from 'swr'

export function useEvalEvents(
  options: MetadataUserEditLoadOptions | undefined
) {
  const { authorizedAxios, isAuthenticated } = useGeckoAuth()
  const { ROLODEX_URL } = useRuntimeVariables()
  return useSWR<DocumentPageMetadataUserEditEntry[], Error>(
    options && isAuthenticated ? evalEventsKey(ROLODEX_URL, options) : null,
    () => {
      if (!options) throw new Error('Eval event scope is required')
      return loadEvalEvents({
        axios: authorizedAxios,
        rolodexUrl: ROLODEX_URL,
        loadOptions: options,
      })
    },
    { keepPreviousData: false }
  )
}
